
export const MESSAGE_NOT_ONLINE = 'Keine Internetverbindung vorhanden.\nBitte versuchen Sie es später erneut.';
export const MESSAGE_SERVICE_NOT_AVAILABLE = 'Der Dienst steht aktuell leider nicht zur Verfügung.\nBitte versuchen Sie es später erneut.';




// WEBPACK FOOTER //
// ./src/config.js